exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3lhaza0urCLW5Tjx1eA7q8{width:100%;min-height:80px;height:80px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2IQpIn0UF3OF_CtC-Awq--{width:100%}html[dir=ltr] ._2IQpIn0UF3OF_CtC-Awq--{padding-left:28px}html[dir=rtl] ._2IQpIn0UF3OF_CtC-Awq--{padding-right:28px}html[dir=ltr] ._3k6AvnRFUO3tG41WIiypfj{margin-right:8px}html[dir=rtl] ._3k6AvnRFUO3tG41WIiypfj{margin-left:8px}html[dir] ._1I_DFx572-unqbWKtddTCk .ms-Button:active{background-color:\"[theme:neutralLight, default:#eaeaea]\";border-color:\"[theme:neutralLight, default:#eaeaea]\"}._1I_DFx572-unqbWKtddTCk .ms-Button:active .ms-Button-label{color:\"[theme:black, default:#000000]\"}", ""]);

// exports
exports.locals = {
	"container": "_3lhaza0urCLW5Tjx1eA7q8",
	"buttonContainer": "_2IQpIn0UF3OF_CtC-Awq--",
	"button": "_3k6AvnRFUO3tG41WIiypfj",
	"cancelButtonContainer": "_1I_DFx572-unqbWKtddTCk"
};